import { Injectable } from '@angular/core';
import { Notification } from './notification';
import { NotificationType } from './notification-type.enum';

@Injectable()
export class NotificationService {

  constructor() { }

  Notifications: Notification[] = [];
  private IntervalMS = 3000;

  Notify(msg: string, type: NotificationType) {
    let notif = new Notification();
    notif.Message = msg;
    notif.Type = type;
    notif.Opacity = 0.9;

    this.Notifications.push(notif);
    setTimeout(() => this.FadeNotification(notif), this.IntervalMS);
  }

  Close(notif: Notification) {
    let idx = this.Notifications.indexOf(notif);
    if (idx > -1) {
      this.Notifications.splice(idx, 1);
    }
  }

  FadeNotification(notif: Notification) {
    notif.Opacity -= 0.1;
    if (notif.Opacity > 0.1) {
      setTimeout(() => this.FadeNotification(notif), this.IntervalMS);
    } else {
      this.Close(notif);
    }
  }

}



// WEBPACK FOOTER //
// D:/OTHERS/FirstmediaShowSchedule/src/app/notification/notification.service.ts